import _ from 'lodash';
import {atom, onMount} from 'nanostores';
import {QueryClient} from '@tanstack/react-query';

export const $queryClient = atom(null);

onMount($queryClient, ()=>$queryClient.set(new QueryClient()));

export const invalidateQuery = key=>$queryClient.get().invalidateQueries({queryKey: key});
